import React from 'react';
export function TestimonialsSection() {
  return <section className="py-6 text-gray-800" data-id="element-285">
      <h2 className="text-2xl font-bold mb-6 text-center" data-id="element-286">
        Linda Isn't Alone – Thousands of Women Are Getting Their Lives Back
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-287">
        When I started researching Linda's story, I discovered she's part of a
        growing movement of women who've discovered this natural alternative to
        pills and surgery.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-288">
        <div className="bg-gray-100 p-4 rounded-lg" data-id="element-289">
          <p className="italic mb-4" data-id="element-290">
            "I was scheduled for knee replacement surgery. After using this
            device for 6 weeks, I canceled the surgery. My orthopedist couldn't
            believe the improvement."
          </p>
          <p className="font-bold" data-id="element-291">Margaret, 62, Denver</p>
        </div>
        <div className="bg-gray-100 p-4 rounded-lg" data-id="element-292">
          <p className="italic mb-4" data-id="element-293">
            "I haven't taken a pain pill in 4 months. This device gave me my
            active lifestyle back without the side effects."
          </p>
          <p className="font-bold" data-id="element-294">Sarah, 45, Atlanta</p>
        </div>
        <div className="bg-gray-100 p-4 rounded-lg" data-id="element-295">
          <p className="italic mb-4" data-id="element-296">
            "My physical therapist asked what I was doing differently. When I
            showed her the device, she said 'That's exactly what we do here, but
            you're getting it at home.'"
          </p>
          <p className="font-bold" data-id="element-297">Carol, 59, Phoenix</p>
        </div>
      </div>
      <h3 className="text-xl font-bold mb-4" data-id="element-298">Professional Recognition</h3>
      <div className="bg-blue-50 p-6 rounded-lg mb-6" data-id="element-299">
        <p className="italic mb-4 leading-relaxed" data-id="element-300">
          "The combination of heat, red light therapy, massage, and compression
          represents the gold standard of non-invasive joint therapy. What's
          exciting is that this technology is now available for home use,
          allowing patients to get professional-level treatment whenever they
          need it."
        </p>
        <p className="font-bold" data-id="element-301">
          Dr. James Richardson, Sports Medicine Physician
        </p>
      </div>
      <h3 className="text-xl font-bold mb-4" data-id="element-302">The Research Backing</h3>
      <p className="mb-4 leading-relaxed" data-id="element-303">
        This isn't based on testimonials alone. The individual therapies have
        extensive scientific support:
      </p>
      <ul className="list-disc pl-8 mb-6 space-y-2" data-id="element-304">
        <li data-id="element-305">
          Heat Therapy: Recommended by the Arthritis Foundation for joint pain
          relief
        </li>
        <li data-id="element-306">
          Red Light Therapy: Over 100 clinical studies showing effectiveness for
          pain and inflammation
        </li>
        <li data-id="element-307">
          Massage Therapy: Proven to improve circulation and reduce muscle
          tension
        </li>
        <li data-id="element-308">
          Compression: Standard treatment for joint support and swelling
          reduction
        </li>
      </ul>
      <h3 className="text-xl font-bold mb-4" data-id="element-309">The Safety Profile</h3>
      <p className="mb-6 leading-relaxed" data-id="element-310">
        Unlike pain medications, this therapy has no known side effects. The FDA
        has cleared similar devices for home use, and the therapy is gentle
        enough to use multiple times per day.
      </p>
      <p className="mb-6 leading-relaxed italic" data-id="element-311">
        "The worst thing that happens is you feel relaxed," Linda jokes.
        "Compare that to the side effect list on a bottle of pain pills."
      </p>
    </section>;
}